'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Full.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Image } from '@/types/common/ImageData'
import { Video } from '@/types/common/VideoData'
import LazyVideo from '@/components/common/LazyVideo'

interface FullProps {
    data: DataProps
}

interface ImageProp {
    image: Image;
}

interface DataProps {
    _type: string;
    _ref: string;
    image: ImageProp;
    video: Video;
}

export default function FullComponent({
    data
}: FullProps) {

    const [isMobile, setIsMobile] = useState(false);

    // Detectar si es mobile o desktop
    useEffect(() => {
        const checkScreenSize = () => setIsMobile(window.innerWidth < 768);
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    return (
        <div className={s.full}>
            {data.video && data.video.videoUrl ?
                <LazyVideo
                    src={isMobile && data.video.videoMobileUrl ? data.video.videoMobileUrl : data.video.videoUrl}
                    autoplay={true}
                    controls={false}
                    defaultInView={true}
                /> : data.image && data.image.image && <div className={s.Image}>
                <LazyImage
                    src={data.image.image.imageUrl}
                    width={data.image.image.metadata.dimensions.width}
                    height={data.image.image.metadata.dimensions.height}
                    blurDataURL={data.image.image.ref}
                    fill={false}
                    alt={data.image.image.attribution || ""}
                    caption={data.image.image.caption || null}
                    filename={data.image.image.filename || ""}
                />
            </div>}
        </div>
    )
}
